import { render, staticRenderFns } from "./no-data.vue?vue&type=template&id=7a19bcea&scoped=true"
import script from "./no-data.vue?vue&type=script&lang=js"
export * from "./no-data.vue?vue&type=script&lang=js"
import style0 from "./no-data.vue?vue&type=style&index=0&id=7a19bcea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a19bcea",
  null
  
)

export default component.exports